const initBigSliderHeading = () => {
    const bigSliderHeadingWidget = document.querySelector("[data-big-slider-heading-widget]");
    if (bigSliderHeadingWidget) {
        const config = new CarouselConfig();
        config.sliderSelector = "[data-big-carousel-heading]";
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showArrows = false;
        config.showDots = true;
        config.groupCells = true;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
